import ObservableService from "../external/ensolvers-core-frontend-mui/submodules/fox-typescript/core/ObservableService";
import User, { UserEvents } from "../external/ensolvers-core-frontend-mui/submodules/fox-typescript/core/User";
import { EnsolversOpsUser } from "../models/EnsolversOpsUser";
import UserService from "./UserService";

class OpsUserService extends ObservableService<UserEvents> {
  async update(user: EnsolversOpsUser): Promise<User> {
    const userUpdate = await UserService.update(user);
    this.notifyObservers(UserEvents.UPDATE, userUpdate.getContentOrThrowError());
    return userUpdate as unknown as User;
  }
}

export default new OpsUserService();
